import { render } from "./nav.vue?vue&type=template&id=5faa34b5&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"

import "./nav.vue?vue&type=style&index=0&id=5faa34b5&lang=css"
import "./nav.vue?vue&type=style&index=1&id=5faa34b5&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faa34b5"]])

export default __exports__